export default __webpack_public_path__ + "static/media/steppers-banner.00cbce24.svg";